import React, { useState, useEffect } from 'react';
// import Select2 from 'react-select2-wrapper';
// import 'select2/dist/css/select2.min.css';
// import 'select2/dist/js/select2.full.min.js';
import Select from 'react-select'
import { UTILS } from '../../constants';
import axios from 'axios';
import { toast } from 'react-toastify';

export const AddTeam = ({ setgetId, teams, cardDetail, selectTeamI }) => {
  // const [selectTeamId, setSelectTeamId] = useState(cardDetail?.team?.team_key|| 1);
  // const [formData, setFormData] = useState({
  //   client_id: ((cardDetail.card?.team_key != null)?cardDetail.card.team_key:selectTeamI),
  // });
  // const handleClientChange = (e) => {
  //   setSelectTeamId({
  //     ...formData,
  //     client_id: e.target.value,
  //   });
  // };
  const [selectTeamId, setSelectTeamId] = useState(cardDetail?.team?.team_key || 1);
  const [selectedClient, setSelectedClient] = useState(null);

  // Initialize formData with client_id set from cardDetail or selectTeamId
  const [formData, setFormData] = useState({
    client_id: cardDetail?.card?.team_key || selectTeamId,
  });
  useEffect(() => {
    const initialValue = formData ? formData.client_id : cardDetail?.team?.team_key;
    
    // Find the corresponding option object based on the initial value
    const initialOption = teams.find(team => team.team_key === initialValue);
    
    setSelectedClient(initialOption ? { value: initialOption.team_key, label: initialOption.name } : null);
  }, [formData, cardDetail, teams]);
  // Handle client change event
  const handleClientChange = (e) => {
    const newClientId = e.value;

    // Update both selectTeamId and formData.client_id
    setSelectTeamId(newClientId);
    setFormData((prevFormData) => ({
      ...prevFormData,
      client_id: newClientId,
    }));
  };
  // useEffect(() => {
  //   setSelectTeamId(selectTeamId);
  //   setFormData({client_id: selectTeamId,});
  // }, []);
  // useEffect(() => {
  //   setFormData({client_id: selectTeamId,});
  // }, [selectTeamId]);

  const addTeamFunc = async () => {
    if (!formData.client_id) {
      toast.warning("Please select any team");
      // alert('Change Team');
      return;
    }

    // console.log('formData', formData);

    const randomString = Math.random().toString(36).substring(2, 5);
    const url =
      UTILS.API_url + `board/v1/board-list-cards/change-team?${randomString}`;
    const data = new FormData();

    data.append('task_id', cardDetail?.id); // Assuming task_id is the user_id in your context
    data.append('team_key', formData.client_id);

    try {
      const response = await axios.post(url, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('trelloToken')}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      // console.log('response', response);

      if (response.status === 200) {
        setFormData({
          client_id: '',
          title: '',
        });
        setgetId(null);
        toast.success('Successfully Added');
      }
    } catch (error) {
      toast.error(error.response?.data?.errors?.client_id?.[0]);
    }
  };

  return (
    <div>
      <button className="close-btn-pop close-member">
        <span
          className="material-symbols-outlined"
          onClick={() => setgetId(null)}
        >
          close
        </span>
      </button>
      <h4 className="mem-heading">Change Team</h4>
      <div className="selected_option">
        <div>
          <label>Change Team</label>
          <Select
            name="client_id"
            value={selectedClient}
            onChange={handleClientChange}
            options={teams.map((value) => ({
              value: value.team_key,
              label: value.name,
            }))}
            required
          />

          <button
            className="add_new_card mt-3"
            disabled={formData.client_id == ''}
            onClick={addTeamFunc}
          >
            Change Team
          </button>
        </div>
      </div>
    </div>
  );
};
